export enum Currency {
  EUR = 'EUR',
  USD = 'USD',
  GBP = 'GBP',
  JPY = 'JPY',
  CHF = 'CHF',
  CAD = 'CAD',
  AUD = 'AUD',
  CNY = 'CNY',
  SEK = 'SEK',
  NZD = 'NZD',
}

export const DEFAULT_CURRENCY = Currency.EUR;
